import {OffersBlock} from "@/lib/interfaces/blocks";
import BonusTickIcon from "@/components/icons/BonusTickIcon";
import SectionContent from "@/components/SectionContent";
import React from "react";
import Image from "next/image";
import {Offer} from "@/lib/interfaces/offers";
import dynamic from "next/dynamic";
import "@/styles/offers.scss";
import {TrackingLink} from "@/components/TrackingLink";
import Link from "next/link";
import SectionTitle from "@/components/SectionTitle";

const Table = dynamic(
    () => import("@/components/Table"),
    { ssr: false }
);

interface OffersSectionProps {
    children: React.ReactNode
    type: string
}

function OffersSection({children, type}: OffersSectionProps) {
    return (
        <section className={`eo-sportsbook-list ${type}`}>
            <SectionContent>
                {children}
            </SectionContent>
        </section>
    )
}

type OffersType = {
    block: OffersBlock
}

function SportsbookLogo({offer}: {offer: Offer}) {
    return (
        <div className="sportsbook-logo">
            <div className="logo-wrap">
                <div className="logo-box" style={{ backgroundColor: `${offer.brand.background_colour}` }}>
                    <Image width={150} height={75} className="logo-image" src={`${offer.brand.media[0]?.original_webp}, ${offer.brand.media[0].original_webp}, ${offer.brand.media[0].original_png}`} alt={`Logo for ${offer.brand.title}`}/>
                </div>
                {/*{offer.featured ? <div className="logo-label" dangerouslySetInnerHTML={{__html: offer.brand.benefits[0].description}}></div> : null}*/}
            </div>
        </div>
    )
}

function SportsbookOfferTitle({offer}: {offer: Offer}) {
    return (
        <span className="sportsbook-offerTitle-popup">
            {offer.title}
        </span>
    )
}

function SportsbookPlay({offer, buttonText = "Play"}: {offer: Offer, buttonText?: string}) {
    return (
        <div className="sportsbook-play-popup">
            <TrackingLink source={"offer"}>
                <Link href={offer.url} target={"_blank"} className="eo-button play-button" style={{justifyContent: 'center'}} aria-label={`Play with ${offer.brand.title}`}>{buttonText}</Link>
            </TrackingLink>
        </div>
    )
}

export default function PopUpOffers({ offers }: {offers: Offer[]}) {
    return (
        <OffersSection type={"m-offers"}>
            {offers.map((offer) => (
                <div key={offer.id} className={`eo-sportsbook typ-offer ${offer.featured ? 'm-spotlight' : ''}`}>
                <div className="sportsbook-backdrop popup"></div>
                <SportsbookLogo offer={offer}/>
                <SportsbookOfferTitle offer={offer}/>
                <SportsbookPlay offer={offer} buttonText={"Play"}/>
                <div className="sportsbook-terms-popup">
                    <div dangerouslySetInnerHTML={{ __html: offer?.terms || "Terms & Conditions Apply, 18+" }} />
                </div>
                </div>
            ))}
        </OffersSection>
    )
}
